ya
<script setup lang="ts">
import Tooltip from "@/components/Tooltip.vue";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    required: true,
    default: "phone-number-input",
  },
  labelText: {
    type: String,
    default: "Phone number",
    required: false,
  },
  required: {
    type: Boolean,
    default: false,
    required: false,
  },
  pattern: {
    type: String,
    default: "^(?:\\d{3}[ ]?\\d{4}|\\d{3}[ ]?\\d{3}[ ]?\\d{3}|\\d{7}|\\d{9})$",
    required: false,
  },
  placeholder: {
    type: String,
    default: "Enter phone number",
    required: false,
  },
  inputClass: {
    type: String,
    default: "form-control",
    required: false,
  },
  formGroupClass: {
    type: String,
    default: "mb-3",
    required: false,
  },
});

const onInput = (event: Event) => {
  const input = event.target as HTMLInputElement;

  emit("update:modelValue", input.value);
};
</script>

<template>
  <b-form-group :class="formGroupClass">
    <label :for="props.id">
      {{ $t(props.labelText) }}
      <Tooltip :value="$t('Phone number input description')" />
      <small v-if="!props.required" class="ms-2 text-lowercase text-nowrap"
        >({{ $t("Optional field") }})</small
      >
    </label>

    <input
      :id="props.id"
      :value="props.modelValue"
      type="text"
      :class="props.inputClass"
      :placeholder="$t(props.placeholder)"
      :pattern="props.pattern"
      :required="props.required"
      maxlength="12"
      @input="onInput"
    />
  </b-form-group>
</template>
